import type { QueryClient } from '@tanstack/react-query';
import { dialogueVoiceoversKeys } from '@/hooks/api/useDialogueVoiceovers';
import {
  storyboardDialoguesKeys,
  type StoryboardDialogueItem,
} from '@/hooks/api/useStoryboardDialogues';
import type { DialogueVoiceoverResponse } from '@/services/api/storyboard-resources';
import { useCollaborationHighlightStore } from '@/stores/collaborationHighlightStore';

export function removeDeletedStoryboardDialogueFromCache(
  queryClient: QueryClient,
  params: {
    storyboardId: string;
    dialogueId: string;
  }
): void {
  const { storyboardId, dialogueId } = params;

  queryClient.setQueryData<StoryboardDialogueItem[]>(
    storyboardDialoguesKeys.list(storyboardId),
    (current = []) => current.filter((item) => item.dialogueId !== dialogueId)
  );

  queryClient.setQueryData<DialogueVoiceoverResponse[]>(
    dialogueVoiceoversKeys.storyboard(storyboardId),
    (current = []) => current.filter((item) => item.dialogueId !== dialogueId)
  );

  useCollaborationHighlightStore.getState().clearHighlight({
    targetType: 'dialogue',
    targetId: dialogueId,
  });
}

export function applyStoryboardDialogueDeletedCacheSync(
  queryClient: QueryClient,
  payload: {
    storyboardId?: string | null;
    entityId?: string | null;
  }
): void {
  const storyboardId = payload.storyboardId?.trim();
  const dialogueId = payload.entityId?.trim();
  if (!storyboardId || !dialogueId) return;

  removeDeletedStoryboardDialogueFromCache(queryClient, { storyboardId, dialogueId });
}
